export enum RecentlyViewedContentType {
  EXERCISE = 'exercise',
  WORKOUT = 'workout',
  PROGRAM = 'program',
  MEAL = 'meal',
  NUTRITION_PLAN = 'nutrition_plan',
}
